import { Box } from './Box.js';

class Fullpage {
    constructor() {
        this.container = document.querySelector('.js-fullpage');
        this.inner = this.container.querySelector('.js-fp-inner');
        this.screens = this.container.querySelectorAll('.js-fp-screen');
        this.slidesLength = this.screens.length;
        this.allowSlides = false;
        this.DURATIONCHANGE = 1000;
        this.DURATIONBOX = 700;

        this.indexActive = 0;
        this.indexOld = 0;
        this.indexNext = 1;
        this.indexPrev = -1;
        this.isBox = false;

        if (this.container.querySelector('.js-fp-box')) {
            this.box = new Box(this.container.querySelector('.js-fp-box'));
        }

        this.checkSize();
        this.bindScrollTop();
        this.bindResize();
        this.bindMouseWheel();
        this.bindClick();
        this.bindTouchMove();
    }

    /**
     * Привязываем событие скролла наверх, для поэкранного скролла
     * */
    bindScrollTop() {
        App.H.on('fullpage.scrollTop', () => {
            this.scrollToFirstSlide();
        });
    }


    /**
     * Делаем поэкранный скролл только
     * на экранах достаточного размера
     */
    checkSize() {
        const w = window.innerWidth;
        const h = window.innerHeight;

        if (!App.mobile && w > 999 && h > 650) {
            this.allowSlides = true;
            document.querySelector('html').classList.add('_is-fullpage');
        } else {
            this.allowSlides = false;
            document.querySelector('html').classList.remove('_is-fullpage');
        }
    }



    /**
     * Перепроверяем при ресайзе
     */
    bindResize() {
        App.W.on('resized orientationchange', () => {
            this.checkSize();
        });
    }



    /**
     * Переключение колесом мыши
     */
    bindMouseWheel() {
        App.W.on('wheeldown', () => {
            this.nextSlide();
        });

        App.W.on('wheelup', () => {
            this.prevSlide();
        });
    }

    scrollToFirstSlide() {
        this.indexOld = -1;
        this.indexActive = 0;
        this.changeSlide('top');
    }


    /**
     * Переключаем
     */
    nextSlide() {
        if (this.animationFlag || App.menuIsOpen || !this.allowSlides) { return; }

        if (this.isBox) {
            this.nextBox();
            return;
        }

        this.indexOld = this.indexActive;
        this.indexActive++;
        this.orderIndexes();
        this.changeSlide('forward');
    }

    prevSlide() {
        if (this.animationFlag || App.menuIsOpen || !this.allowSlides) { return; }

        if (this.isBox) {
            this.prevBox();
            return;
        }

        this.indexOld = this.indexActive;
        this.indexActive--;
        this.orderIndexes();
        this.changeSlide('backward');
    }

    changeSlide(direction) {
        if (this.animationFlag || !this.allowSlides) { return; }
        if (this.indexActive == this.indexOld) { return; }

        if (this.indexActive >= 1) {
            App.H.addClass('_is-scroll-top');
        } else {
            App.H.removeClass('_is-scroll-top');
        }

        // Определяем, находимся ли мы на слайде с коробкой
        this.isBox = [...this.screens]
            .filter(s => +s.getAttribute('data-id') === this.indexActive)[0]
            .classList.contains('js-fp-box');

        // Делаем задержку, чтобы не было одновременных анимаций
        this.animationFlag = true;

        // Двигаем контейнер
        this.inner.style.transform = `translateY(calc(var(--vh, 1vh) * 100 * -${this.indexActive}))`;

        // Подставляем классы активному слайду и соседним
        this.screens.forEach(screen => {
            const id = +screen.getAttribute('data-id');

            if (id === this.indexActive) {
                screen.classList.add('_is-active');
                screen.classList.remove('_is-prev', '_is-next');
            } else if (id < this.indexActive) {
                screen.classList.remove('_is-active', '_is-next');
                screen.classList.add('_is-prev');
            } else {
                screen.classList.remove('_is-active', '_is-prev');
                screen.classList.add('_is-next');
            }
        });

        // Скрываем или показываем хедер в зависимости от направления скролла
        if (direction === 'top') {
            this.indexOld = 0;
            document.querySelector('html').classList.remove('_is-header-hidden');
        } else if (direction === 'forward') {
            document.querySelector('html').classList.add('_is-header-hidden');
        } else if (direction === 'backward') {
            document.querySelector('html').classList.remove('_is-header-hidden');
        }


        setTimeout(() => {
            this.checkHeader();
        }, this.DURATIONCHANGE * 0.5);


        setTimeout(() => {
            this.animationFlag = false;
        }, this.DURATIONCHANGE);
    }



    /**
     * Ограничиваем перемотку кол-вом слайдов
     */
    orderIndexes() {
        if (this.indexActive >= this.slidesLength) {
            this.indexActive = this.slidesLength - 1;
        }

        if (this.indexActive < 0) {
            this.indexActive = 0;
        }
    }



    /**
     * Переключение тачем на мобильных
     */
    bindTouchMove() {
        let event = null;

        this.container.addEventListener('touchstart', e => {
            event = e;
        });

        this.container.addEventListener('touched', () => {
            event = null;
        });

        this.container.addEventListener('touchmove', e => {
            if (event) {
                const delta = e.touches[0].pageY - event.touches[0].pageY;

                if (delta > 10) {
                    this.prevSlide();
                } else if (delta < -10) {
                    this.nextSlide();
                }
            }
        });
    }



    /**
     * Переключаем кликом по кнопке
     */
    bindClick() {
        this.container.querySelectorAll('.js-fp-next').forEach(btn => {
            btn.addEventListener('click', () => {
                if (this.allowSlides) {
                    /**
                     * При поэкранном скролле всегда прокручиваем
                     * до следующего основного слайда, даже если
                     * кнопка находится в кадре с коробкой
                     */
                    this.isBox = false;
                    this.nextSlide();
                } else {
                    /**
                     * При обычном скролле сначала определяем,
                     * куда нам нужно доскроллить (потому что
                     * нумерация у всех слайдов, включая кадры
                     * с коробкой, получается не сквозная — они
                     * на разных уровнях)
                     */
                    const parent = btn.closest('.js-fp-screen') || btn.closest('.js-fp-box');

                    if (parent.classList.contains('js-fp-box')) {
                        /**
                         * Это кнопка в кадре с коробкой, поэтому определяем,
                         * куда дальше скроллить — до следующего кадра
                         * или до следуюшего основного слайда,
                         * если это последний кадр с коробкой
                         */
                        const screen = btn.closest('.js-fp-box-screen');

                        if (screen.matches(':last-child')) {
                            // К следующему основному слайду
                            const id = +parent.getAttribute('data-id');
                            this.scrollToNext(id);
                        } else {
                            // К следующему кадру с коробкой
                            const id = +screen.getAttribute('data-box');
                            this.scrollToNextBox(id);
                        }
                    } else {
                        /**
                         * Это кнопка в основном слайдер, поэтому
                         * и скроллим сразу к следующему основному
                         */
                        const id = +parent.getAttribute('data-id');
                        this.scrollToNext(id);
                    }
                }
            });
        });
    }



    /**
     * При обычном скролле проматываем
     * до следующего блока
     */
    scrollToNext(id) {
        const target = this.container.querySelector(`.js-fp-screen[data-id="${id + 1}"]`);

        if (target) {
            const top = target.offsetTop;

            $('html, body').animate({
                scrollTop: top
            }, 500);
        }
    }

    scrollToNextBox(id) {
        const target = this.container.querySelector(`.js-fp-box-screen[data-box="${id + 1}"]`);

        if (target) {
            const top = target.offsetTop;

            $('html, body').animate({
                scrollTop: top
            }, 500);
        }
    }


    /**
     * Меняем подложку хедера при поэкранном скролле
     */
    checkHeader() {
        const screen = this.container.querySelector('.js-fp-screen._is-active');

        if (screen.classList.contains('fp-screen--img')
            && !screen.classList.contains('fp-screen--text')) {
            document.querySelector('html').classList.add('page-tr');
        } else {
            document.querySelector('html').classList.remove('page-tr');
        }
    }


    /**
     * В зависимости от того, находимся мы на слайде
     * с коробкой или нет, меняем либо кадры коробки,
     * либо общий слайд. Другими словами, пока можно
     * прокручивать кадры с коробкой — прокручиваем их,
     * когда упираемся в крайний кадр коробки — скроллим
     * дальше основные слайды
     */
    nextBox() {
        /**
         * Если это последний слайд у коробки,
         * то пролистываем дальше общий слайдер
         */
        if (this.box.isOnLast()) {
            this.isBox = false;
            this.nextSlide();
        } else {
            /**
             * Если нет, то меняем слайд у коробки
             */
            this.animationFlag = true;

            this.box.nextSlide();

            setTimeout(() => {
                this.animationFlag = false;
            }, this.DURATIONBOX);
        }
    }

    /**
     * То же самое, только в обратном направлении
     */
    prevBox() {
        if (this.box.isOnFirst()) {
            this.isBox = false;
            this.prevSlide();
        } else {
            this.animationFlag = true;

            this.box.prevSlide();

            setTimeout(() => {
                this.animationFlag = false;
            }, this.DURATIONBOX);
        }
    }
}

if (document.querySelector('.js-fullpage')) {
    new Fullpage();
}



// WEBPACK FOOTER //
// ./_src/js/Fullpage.js